import React from "react"
import { Helmet } from "react-helmet"
import { useTranslation } from "gatsby-plugin-react-i18next"
import displayFont from "./fonts/bricolage-grotesque-500-800-latin.woff2"
import textFont from "./fonts/ibm-plex-sans-latin.woff2"
import { Header, Footer } from "src/components/theme"
import { useHashScrollOnLoad } from "src/utils/scroll"
import { Global, SkipLink } from "./styles"
import "./fonts.css"

export const Layout = ({ children }) => {
  const { t } = useTranslation()
  useHashScrollOnLoad()
  return (
    <>
      <Helmet>
        <link
          rel="preload"
          href={displayFont}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href={textFont}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Global />
      <SkipLink href="#main">{t("skip_to_content")}</SkipLink>
      <Header />
      <main id="main">{children}</main>
      <Footer />
    </>
  )
}
